import React from "react";

const URL_RE = /\b((?:https?:\/\/|www\.)[^\s<]+)/gi;
const TRAILING_PUNCT = /[.,;:!?]+$/;

function splitMatch(raw) {
  let core = raw.replace(TRAILING_PUNCT, "");
  if (core.endsWith(")") && !core.includes("(")) {
    core = core.slice(0, -1);
  }
  return { core, trailing: raw.slice(core.length) };
}

function safeHref(display) {
  const href = /^https?:\/\//i.test(display) ? display : `https://${display}`;
  try {
    const url = new URL(href);
    if (url.protocol !== "http:" && url.protocol !== "https:") return null;
    return url.href;
  } catch {
    return null;
  }
}

export function linkifyParts(text) {
  const source = String(text || "");
  const parts = [];
  const re = new RegExp(URL_RE);
  let last = 0;
  let match;
  while ((match = re.exec(source))) {
    if (match.index > last) {
      parts.push({ type: "text", value: source.slice(last, match.index) });
    }
    const { core, trailing } = splitMatch(match[1]);
    const href = safeHref(core);
    if (href) {
      parts.push({ type: "link", href, value: core });
    } else {
      parts.push({ type: "text", value: core });
    }
    if (trailing) {
      parts.push({ type: "text", value: trailing });
    }
    last = match.index + match[1].length;
  }
  if (last < source.length) {
    parts.push({ type: "text", value: source.slice(last) });
  }
  return parts;
}

export function LinkifiedText({ text }) {
  return linkifyParts(text).map((part, i) =>
    part.type === "link" ? (
      <a key={i} href={part.href} target="_blank" rel="noopener noreferrer">
        {part.value}
      </a>
    ) : (
      <React.Fragment key={i}>{part.value}</React.Fragment>
    )
  );
}
